import React, { useEffect, useState } from "react";
import {
  CButton,
  CCol,
  CForm,
  CFormGroup,
  CInput,
  CInputGroup,
  CInputGroupAppend,
  CInputGroupText,
  CLabel,
  CModalBody,
  CModalFooter,
  CRow,
  CSpinner,
  CTextarea,
} from "@coreui/react";
import { ID_FORM_ORDER } from "../RenderModalFormOrder";
import axios from "axios";
import { apis } from "src/constants";
import refreshToken from "src/token/refreshToken";
import Select from "react-select";
import { getOptionListAdmin } from "src/functions/getData";
import { useSelector } from "react-redux";
import {
  formatPhone,
  formatPhoneForSave,
  maxLengthCheck,
} from "src/functions/baseFunction";

const FormOrderFlash = ({ data, handleCloseModal }) => {
  const listAdminRedux = useSelector((state) => state.listAdmin.data);

  const optionsAdmin = getOptionListAdmin(listAdminRedux);

  const [selectedAdmins, setSelectedAdmins] = useState([]);

  const [validated, setValidated] = useState(false);
  const [order, setOrder] = useState(null);
  const [isLoadingSubmit, setLoadingSubmit] = useState(false);

  useEffect(() => {
    if (data.admin_id) {
      setSelectedAdmins(JSON.parse(data.admin_id));
    }

    setOrder(data);
  }, []);

  const handleSubmitForm = async (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setLoadingSubmit(true);
      await updateInfo(event);
      setLoadingSubmit(false);
    }
    setValidated(true);
  };

  const updateInfo = async (event) => {
    const {
      address,
      phone,
      name_user,
      flash_detail_buy,
      delivery_charge,
      note,
      note_private,
    } = event.target.elements;

    const body = {
      flash_detail_buy: flash_detail_buy.value,
      address: address.value,
      delivery_charge: delivery_charge.value
        ? `${delivery_charge.value}000`
        : 0,
      phone: formatPhoneForSave(phone.value),
      name_user: name_user.value,
      note: note.value,
      note_private: note_private.value,
      admin_id: JSON.stringify(selectedAdmins),
    };

    const userLocal = JSON.parse(localStorage.getItem("@loginData"));
    try {
      await axios.put(
        apis.apiOrder + `admin/update-info/flash/${order.id}`,
        body,
        {
          headers: {
            verify: userLocal.accessToken,
          },
        }
      );

      handleCloseModal();
    } catch (error) {
      if (error.response?.status === 401) {
        await refreshToken(userLocal);
        await updateInfo(event);
      } else if (error.response?.status === 400) {
        alert(error.response.data);
      } else {
        alert(error.response.data);
      }
    }
  };

  return (
    <div>
      <CModalBody>
        <CForm
          onSubmit={handleSubmitForm}
          id={ID_FORM_ORDER}
          noValidate
          wasValidated={validated}
          autoComplete="off"
        >
          <CFormGroup row>
            <CCol md="6">
              <Select
                isMulti
                placeholder="Chọn nhân viên trực"
                options={optionsAdmin}
                value={optionsAdmin.filter((obj) =>
                  selectedAdmins.includes(obj.value)
                )}
                onChange={(e) =>
                  setSelectedAdmins(
                    Array.isArray(e) ? e.map((x) => x.value) : []
                  )
                }
                // isDisabled={type === TYPE_EDIT ? true : false}
              />
            </CCol>
          </CFormGroup>

          <CRow>
            <CCol xs="7">
              <CFormGroup>
                <CLabel
                  htmlFor="flash_detail_buy"
                  style={{ fontWeight: "bold" }}
                >
                  Nội dung đơn
                </CLabel>
                <CTextarea
                  defaultValue={order ? order.flash_detail_buy : ""}
                  name="flash_detail_buy"
                  rows="5"
                  required
                />
              </CFormGroup>
            </CCol>
            <CCol xs={"5"}>
              <CFormGroup>
                <CLabel htmlFor="address" style={{ fontWeight: "bold" }}>
                  Địa chỉ nhận hàng
                </CLabel>
                <CTextarea
                  defaultValue={order ? order.address : ""}
                  name="address"
                  rows="5"
                  required
                />
              </CFormGroup>
            </CCol>
          </CRow>

          <CFormGroup row className="my-0">
            <CCol xs="4">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                <div style={{ flex: 1 }}>
                  <CLabel htmlFor="phone" style={{ fontWeight: "bold" }}>
                    SĐT nhận hàng
                  </CLabel>
                  <CInput
                    defaultValue={order ? formatPhone(order.phone) : ""}
                    name="phone"
                    type="number"
                    required
                  />
                </div>
              </div>
            </CCol>
            <CCol xs="5">
              <CFormGroup>
                <CLabel htmlFor="name_user" style={{ fontWeight: "bold" }}>
                  Tên người nhận hàng
                </CLabel>
                <CInput
                  defaultValue={order ? order.name_user : ""}
                  name="name_user"
                  required
                />
              </CFormGroup>
            </CCol>
            <CCol xs="3">
              <CFormGroup>
                <CLabel
                  htmlFor="delivery_charge"
                  style={{ fontWeight: "bold" }}
                >
                  Phí giao hàng
                </CLabel>
                <CFormGroup row>
                  <CCol>
                    <CInputGroup>
                      <CInput
                        defaultValue={
                          order ? parseInt(order.delivery_charge) / 1000 : ""
                        }
                        name="delivery_charge"
                        type="number"
                        maxLength="4"
                        onInput={maxLengthCheck}
                        onWheel={(e) => e.target.blur()}
                      />
                      <CInputGroupAppend>
                        <CInputGroupText>.000</CInputGroupText>
                      </CInputGroupAppend>
                    </CInputGroup>
                  </CCol>
                </CFormGroup>
              </CFormGroup>
            </CCol>
          </CFormGroup>

          <CFormGroup row>
            <CCol xs="6">
              <CLabel htmlFor="note" style={{ fontWeight: "bold" }}>
                Ghi chú, dặn dò cho tài xế
              </CLabel>
              <CTextarea
                defaultValue={order ? order.note : ""}
                name="note"
                rows="2"
                placeholder={"Viết lời ghi chú, dặn dò cho tài xế (nếu có)"}
              />
            </CCol>
            <CCol xs="6">
              <CLabel htmlFor="note_private" style={{ fontWeight: "bold" }}>
                Ghi chú riêng tư
              </CLabel>
              <CTextarea
                defaultValue={order ? order.note_private : ""}
                name="note_private"
                rows="2"
                placeholder="Ghi chú riêng tư chỉ hiển thị cho văn phòng"
              />
            </CCol>
          </CFormGroup>
        </CForm>
      </CModalBody>
      <CModalFooter style={{ padding: 5 }}>
        <CButton color="secondary" onClick={handleCloseModal}>
          Đóng
        </CButton>
        <CButton
          disabled={isLoadingSubmit}
          color={"success"}
          form={ID_FORM_ORDER}
          type={"submit"}
        >
          {isLoadingSubmit && (
            <CSpinner component="span" size="sm" aria-hidden="true" />
          )}
          Cập nhật
        </CButton>
      </CModalFooter>
    </div>
  );
};

export default FormOrderFlash;
